<template>
  <svg
    width="120"
    height="120"
    viewBox="0 0 120 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.6"
      d="M100 34H34.0001V105H100V34Z"
      :fill="cssVars.colorLine100"
    />
    <path
      d="M100.495 33.9265H54.7549L27 40.8293V49.7672C27 49.7672 52.4006 60.3339 51.728 63.1778C51.0553 66.0217 90.4051 60.3339 90.4051 60.3339L100.495 33.9265Z"
      :fill="cssVars.colorGray4"
    />
    <path
      d="M15 27.4968V83.5032C15 87.0913 17.9087 90 21.4968 90H85.5033C89.0913 90 92 87.0913 92 83.5032V27.4968C92 23.9087 89.0913 21 85.5033 21H21.4968C17.9087 21 15 23.9087 15 27.4968Z"
      :fill="cssVars.colorSurface400"
      :stroke="cssVars.colorGray6"
      stroke-width="1.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M46.429 57.4848C46.5354 56.08 47.1687 54.7671 48.2022 53.8092C49.2357 52.8513 50.5931 52.319 52.0025 52.319C53.4119 52.319 54.7693 52.8513 55.8028 53.8092C56.8363 54.7671 57.4697 56.08 57.576 57.4848H46.429ZM63.4838 51.7225C62.0189 49.6363 60.0158 47.986 57.6874 46.947C60.299 45.9283 62.2577 45.9123 63.2609 46.947C64.2641 47.9817 64.2323 49.478 63.4838 51.7225ZM38.9288 64.9823C40.0165 67.6946 41.9194 70.0027 44.3748 71.5883C43.2522 72.101 42.0522 72.4238 40.8237 72.5434C40.3801 72.6066 39.928 72.5754 39.4972 72.452C39.0664 72.3286 38.6665 72.1156 38.3236 71.8271C37.1612 70.6651 37.3841 68.1819 38.9288 64.9823ZM64.2004 52.8208C64.7589 51.4188 65.0349 49.9204 65.0126 48.4115C65.0102 47.1579 64.5322 45.9518 63.6749 45.0368C62.0825 43.445 57.7511 43.6838 53.0217 45.7691H52.0025C48.8739 45.7643 45.833 46.8028 43.3612 48.7201C40.8894 50.6374 39.1279 53.324 38.3555 56.3547L38.1007 57.3893L38.7536 56.5457C40.2705 54.5118 42.1689 52.7925 44.343 51.4837L43.4194 52.4069C41.6241 54.1859 40.0423 56.1678 38.7058 58.3126C37.5418 60.1975 36.6013 62.2114 35.9032 64.3137C35.3388 65.932 35.0378 67.6303 35.0114 69.3439C34.928 70.5361 35.304 71.715 36.0624 72.6389C36.5595 73.1049 37.1461 73.4652 37.7866 73.6977C38.4272 73.9303 39.1083 74.0304 39.7887 73.992C41.8672 73.9078 43.9011 73.3641 45.7443 72.4002C47.6913 73.375 49.8409 73.8767 52.0184 73.8646C54.9555 73.8623 57.8179 72.9396 60.2031 71.2264C62.5882 69.5131 64.3761 67.0956 65.3151 64.3137L65.4107 64.0113H57.4486V64.1227C56.9456 65.05 56.2014 65.8243 55.2947 66.3639C54.388 66.9034 53.3523 67.1883 52.2971 67.1883C51.2419 67.1883 50.2062 66.9034 49.2995 66.3639C48.3928 65.8243 47.6486 65.05 47.1456 64.1227C46.6943 63.3177 46.438 62.4181 46.3972 61.4962H65.9202V61.2893C65.9756 60.7605 66.0022 60.2291 65.9999 59.6975C65.9993 57.289 65.3797 54.9211 64.2004 52.8208Z"
      :fill="cssVars.colorGray4"
    />
    <path
      d="M15.5 36.836L92 36.836"
      :stroke="cssVars.colorGray6"
      stroke-width="1.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <ellipse
      cx="24.0605"
      cy="29.4903"
      rx="2.16559"
      ry="2.16559"
      :fill="cssVars.colorGray4"
    />
    <ellipse
      cx="29.8354"
      cy="29.4903"
      rx="2.16559"
      ry="2.16559"
      :fill="cssVars.colorGray4"
    />
    <ellipse
      cx="35.6104"
      cy="29.4903"
      rx="2.16559"
      ry="2.16559"
      :fill="cssVars.colorGray4"
    />
    <path
      d="M88.0274 54.8423C73.6529 54.8423 62 66.2554 62 80.3342C62 89.0578 66.474 96.758 73.2973 101.354C77.2879 104.041 81.9327 102.22 86.6486 102.459C91.2081 102.69 95.8342 103.442 100 101.354V57.6935C96.4159 55.8717 92.3444 54.8423 88.0274 54.8423Z"
      :fill="cssVars.colorLine100"
    />
    <path
      d="M87.8328 99.7065C98.597 99.7065 107.323 90.9803 107.323 80.2161C107.323 69.4519 98.597 60.7258 87.8328 60.7258C77.0686 60.7258 68.3425 69.4519 68.3425 80.2161C68.3425 90.9803 77.0686 99.7065 87.8328 99.7065Z"
      :fill="cssVars.colorSurface400"
      :stroke="cssVars.colorGray6"
      stroke-width="1.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <circle
      cx="87.8327"
      cy="80.2161"
      r="14.6177"
      :fill="cssVars.colorGray4"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M87.6928 71.283C86.3264 71.283 85.2625 72.469 85.4104 73.8274L86.1911 80.9968C86.2745 81.7632 86.9218 82.3438 87.6928 82.3438C88.4638 82.3438 89.111 81.7632 89.1945 80.9968L89.9752 73.8274C90.1231 72.469 89.0591 71.283 87.6928 71.283ZM87.7228 87.7329C88.9867 87.7329 90.0113 86.7083 90.0113 85.4444C90.0113 84.1805 88.9867 83.156 87.7228 83.156C86.4589 83.156 85.4343 84.1805 85.4343 85.4444C85.4343 86.7083 86.4589 87.7329 87.7228 87.7329Z"
      :fill="cssVars.colorSurface400"
    />
    <path
      d="M116.826 18.5181C117.332 19.5287 116.971 20.7559 115.96 21.2612L111.124 23.7155C110.113 24.2209 108.886 23.8599 108.381 22.8493C107.875 21.8387 108.236 20.6115 109.247 20.1062L114.083 17.6519C115.094 17.1466 116.321 17.5797 116.826 18.5181Z"
      :stroke="cssVars.colorGray4"
      stroke-width="1.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M106.648 10L103.472 15.7749"
      :stroke="cssVars.colorGray4"
      stroke-width="1.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useNamespace } from '@jdesign-vue/hooks'

let id = 0
export default defineComponent({
  name: 'BrowserEmpty',
  setup() {
    const ns = useNamespace('empty')

    const cssVars = {
      colorLine100: `var(${ns.cssVarName('color-line-100')})`,
      colorGray4: `var(${ns.cssVarName('color-gray-4')})`,
      colorGray6: `var(${ns.cssVarName('color-gray-6')})`,
      colorSurface400: `var(${ns.cssVarName('color-surface-400')})`,
    }

    return {
      ns,
      id: ++id,
      cssVars,
    }
  },
})
</script>